const alpha = value => {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true
    }
    return /^[a-zA-Z0-9#/ $@]+$/.test(value)
  };
  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
};

export {alpha,debounce};